<template>
  <ModalDialog
    v-model="isShow"
    :useWhiteBgCloseButton="true"
    :level="9.1"
    :showInLeft="showInLeft"
    @close="hideModal()"
  >
    <div class="p-2" slot="dialog-content">
      <FilePreview :url="url" />
      <div
        class="pl-4 pr-4 d-flex"
        :class="isImage || isPdf || isOfficeDoc ? 'pt-2 pb-2' : 'pb-4'"
      >
        <button
          v-if="additionalBtn && additionalBtn.label"
          class="mylisting-button dark-button"
          @click="additionalBtn.onClick"
        >
          {{ additionalBtn.label }}
        </button>
        <div class="space-item"></div>
        <button
          class="mylisting-button secondary-button cancel-button"
          @click="hideModal()"
        >
          {{ getLabelByKeys("BUTTONS.CLOSE") }}
        </button>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
import ModalDialog from "./ModalDialog";
import VueDocPreview from "vue-doc-preview";
import FilePreview from "../documents/FilePreview.vue";

export default {
  name: "FilePreviewDialog",
  data() {
    return {
      isShow: false,
      url: "",
      showInLeft: false,
      additionalBtn: null,
    };
  },
  components: {
    ModalDialog,
    VueDocPreview,
    FilePreview,
  },
  created() {
    this.$store.watch(
      (state) => state.general.filePreview,
      async (value) => {
        if (!value) {
          this.isShow = false;
          this.showFilePreviewDialog(null);
          return;
        } else {
          if (this.isShow) {
            return;
          }
          this.url = value.url;
          this.additionalBtn = value.additionalBtn;

          this.showInLeft = this.getShowInLeft();
          if (this.isPdf || this.isImage || this.isOfficeDoc) {
            this.isShow = true;
          } else {
            this.openResourceURLDirectly();
          }
        }
      },
      { immediate: true }
    );
  },
  computed: {
    fileExtension() {
      try {
        return this.url.split(".").pop().toLowerCase();
      } catch (e) {
        return null;
      }
    },
    isPdf() {
      return this.fileExtension === "pdf";
    },
    isImage() {
      return ["png", "jpg", "jpeg"].includes(this.fileExtension);
    },
    isOfficeDoc() {
      return ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(
        this.fileExtension
      );
    },
    isIphone() {
      return this.getMobileOperatingSystem() === "iOS";
    },
  },
  methods: {
    hideModal() {
      this.isShow = false;
      this.showFilePreviewDialog(null);
    },
    openResourceURLDirectly() {
      if (!this.url) {
        return;
      }
      window.open(this.url, "_blank");
    },
    getShowInLeft() {
      // Check if the component is showed in the dialog or in the screen
      const interviewTab = document.getElementById("interview-profile");
      if (interviewTab != null) {
        return true;
      }
      // Check if the component is showed in the job posting dialog
      const jobPostingDialogEl = document.getElementById("job-posting-dialog");
      if (jobPostingDialogEl != null) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.image-preview-container {
  height: calc(90vh - 2rem - 44px);
  overflow: auto;
}

.pdf-preview-container {
  height: calc(90vh - 2rem - 44px);
  overflow: auto;
}

.download-button {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/global-dialogs/FilePreviewDialog.vue